module.exports = __webpack_public_path__ + "static/media/click-1263.0f75dd80.svg";